// src/processors/resource/resource-parser.ts - Resource Parsing Operations
import { XConVitePluginOptions } from '../../types';
import {Logger} from "../../utils/logger";

/**
 * Handles parsing of resource sections and individual resource tags
 */
export class ResourceParser {
    constructor(
        private options: Required<XConVitePluginOptions>,
        private logger: Logger
    ) {}

    /**
     * Extract resources section from xchtml content
     */
    extractResourcesSection(templateContent: string): string | null {
        const resourcesMatch = templateContent.match(/<resources[^>]*>([\s\S]*?)<\/resources>/);
        return resourcesMatch ? resourcesMatch[1] : null;
    }

    /**
     * Parse all resource tags from resources section
     */
    parseResourceTags(resourcesSection: string): string[] {
        const resourceMatches = resourcesSection.match(/<resource[^>]*\/?>|<resource[^>]*>[\s\S]*?<\/resource>/g);
        return resourceMatches || [];
    }

    /**
     * Parse individual resource tag into resource object
     */
    parseResourceTag(resourceTag: string): any {
        const attributes = this.parseResourceAttributes(resourceTag);

        return {
            name: attributes['name'] || '',
            type: attributes['type'] || 'js',
            extension: attributes['extension'] === 'true',
            url: attributes['url'] || ''
        };
    }

    /**
     * Parse resource attributes from tag string
     */
    parseResourceAttributes(resourceTag: string): Record<string, string> {
        const attributes: Record<string, string> = {};

        // Match attribute="value" or attribute='value' patterns
        const attributeRegex = /(\w+)=["']([^"']*)["']/g;
        let match;

        while ((match = attributeRegex.exec(resourceTag)) !== null) {
            attributes[match[1]] = match[2];
        }

        return attributes;
    }
}